import { Alert } from '@mui/material'
import { useEffect, useState } from 'react'
import { useGetSubscriptionInfoQuery } from 'src/_api/planApi';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IRONER, ZSHIP_ID } from 'src/constants';

export default function PlanExpirationAlert() {
    const { t } = useTranslation("public");
    const { profile } = useSelector((state) => state.entities.profile)

    const { data: subscriptionInfo } = useGetSubscriptionInfoQuery({})

    const [openAlert, setOpenAlert] = useState(false);

    useEffect(() => {
        // Check if subscription info is available and has an end date
        console.log("subscriptionInfo?.endDate:", subscriptionInfo?.endDate);
        if (subscriptionInfo?.endDate) {
            const endDate = moment(subscriptionInfo.endDate);
            const today = moment();

            // Calculate difference in days
            const diffDays = endDate.diff(today, 'days');
            console.log("diffDays:", diffDays);
            // If endDate is in the future and more than 2 days left, remove EXPIRATION_ALERT_CLOSE
            if (diffDays > 2 && endDate.isAfter(today)) {
                localStorage.removeItem("EXPIRATION_ALERT_CLOSE");
            }

            // Check localStorage for EXPIRATION_ALERT_CLOSE
            const isClosed = localStorage.getItem("EXPIRATION_ALERT_CLOSE") === "true";

            // If there are 2 or fewer days left, show the alert unless closed
            if (diffDays <= 2 && diffDays >= 0 && !isClosed) {
                setOpenAlert(true);
            } else {
                setOpenAlert(false);
            }
        }
    }, [subscriptionInfo]);

    const closeAlertHandler = async () => {
        setOpenAlert(false)
        localStorage.setItem("EXPIRATION_ALERT_CLOSE", "true");
    }

    const isThirdPartyMerchant = !!profile?.merchant?.salla?.store_id || !!profile?.merchant?.zid?.store_id || !!IRONER.includes(profile?.merchant?.id) || !!ZSHIP_ID.includes(profile?.merchant?.id)

    return (
        <>
            {
                (!isThirdPartyMerchant && openAlert) ?
                    <Alert
                        variant="filled"
                        onClose={closeAlertHandler}
                        sx={{ mb: 1, color: "white", mx: 1 }}
                        severity="error"
                    >
                        {t("expirationPlanAlert")}
                    </Alert> :
                    <></>
            }
        </>
    )
}
